<template>
  <v-expansion-panels class="panels" :value="0">
    <v-expansion-panel class="panel" v-if="selectedDashboard.hasRaffle">
      <v-expansion-panel-content>
        <v-layout column>
          <v-flex>
            <v-form ref="raffleForm">
              <v-row class="optionsBox">
                <v-col class="optionsBox">
                  <v-autocomplete
                    required
                    v-model="selectedCampaignId"
                    :rules="[v => !!v || 'Select a campaign']"
                    :items="selectableCampaigns"
                    item-text="text"
                    item-value="value"
                    label="Campaign"
                    prepend-icon="mdi-store"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col class="optionsBox">
                  <v-text-field
                    required
                    v-model="winnerCount"
                    :rules="[
                      v => !!v || 'Number of Winners is required',
                      v => /^[0-9]*$/.test(v) || 'Number of Winners should be a number'
                    ]"
                    label="Number of Winners"
                    prepend-icon="mdi-numeric"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="optionsBox">
                <v-col class="optionsBox">
                  <date-picker
                    required
                    :dateRule="true"
                    v-model="startDate"
                    icon="mdi-calendar"
                    label="Start Date"
                    writable
                    min="1900-01-01"
                    max="2100-12-31"
                  >
                  </date-picker>
                </v-col>
                <v-col class="optionsBox">
                  <date-picker
                    required
                    :dateRule="true"
                    v-model="endDate"
                    icon="mdi-calendar"
                    label="End Date"
                    writable
                    :min="startDate"
                    max="2100-12-31"
                  >
                  </date-picker>
                </v-col>
              </v-row>
              <v-row class="optionsBox">
                <v-btn
                  class="button mt-2"
                  color="blue"
                  @click="assignPrizes()"
                  :disabled="disabled"
                >Assign Prizes
                </v-btn>
              </v-row>
              <v-row class="optionsBox">
                <v-btn
                  class="button mt-2"
                  color="green"
                  @click="downloadCSV()"
                  :disabled="!readyToDownload"
                >Download CSV File
                </v-btn>
              </v-row>
            </v-form>
          </v-flex>
        </v-layout>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import DatePicker from "../components/DatePicker.vue";
import moment from "moment";

export default {
  data() {
    return {
      selectableCampaigns: [],
      selectedCampaignId: "",
      winnerCount: "",
      startDate: "",
      endDate: "",
      readyToDownload: false,
      csvContent: ""
    };
  },
  components: { DatePicker },
  computed: {
    ...mapGetters(["selectedDashboard"]),
    disabled () {
      return this.selectedCampaignId == "" || this.winnerCount <= 0 || this.winnerCount == ""
    }
  },
  methods: {
    ...mapActions(["errorHandler", "snackAlert"]),
    assignPrizes() {
      if (!this.$refs.raffleForm.validate()) {
        return this.snackAlert({ message: "Please enter both start date and end date" })
      }
      const method = "post"
      const url = `${this.selectedDashboard.endPoints.base}/raffle`
      const formattedStartDate = moment(this.startDate).format("YYYY-MM-DD")
      const formattedEndDate = moment(this.endDate).format("YYYY-MM-DD")
      const data = {
        campaignId: this.selectedCampaignId,
        numberOfWinners: this.winnerCount,
        startDate: formattedStartDate,
        endDate: formattedEndDate
      };
      axios({ method, url, data })
        .then((response) => {
          if (response.data) {
            this.readyToDownload = true
            this.csvContent = response.data
          } else {
            this.errorHandler(response.data.message || response.data.error)
          }
        })
        .catch((er) => {
          this.errorHandler(er.response.data.error);
        });
    },
    downloadCSV() {
      const blob = new Blob([this.csvContent], { type: 'text/csv' })
      const fileURL = window.URL.createObjectURL(blob)
      const fileName = `${this.winnerCount}winners_${this.selectedCampaignId}.csv`

      const link = document.createElement('a')
      link.setAttribute('href', fileURL)
      link.setAttribute('download', fileName)
      link.click()

      window.URL.revokeObjectURL(fileURL)
    }
  },
  mounted() {
    if (this.selectedDashboard.campaignId === "pg-template-2") {
      this.selectableCampaigns = [
        { text: "PG AT Akatronik Raffle", value: "akatronik-at" },
        { text: "PG AT 0815 Raffle", value: "0815-at" },
        { text: "PG AT MediaMarkt Raffle", value: "mediamarkt-at" },
        { text: "PG AT DiLife Raffle", value: "dilife-at" },
        { text: "PG AT Casa Bugatti Raffle", value: "casa-bugatti-at" },
        { text: "PG AT National Raffle", value: "national-raffle-at" },
        { text: "PG AT Medienkooperation Tickets Raffle", value: "meet-greet-at" },
        { text: "PG CH MediaMarkt Produkt Package Raffle", value: "mediamarkt-ch" }
      ];
    }

    if ("name" in this.selectedDashboard === false) {
      const dashboard = JSON.parse(localStorage.selectedDashboard);
      this.$store.commit("setDashboard", dashboard);
    }
    this.$store.commit("setUserRoles", JSON.parse(localStorage.userRoles));
  }
};
</script>

<style scoped>
.optionsBox {
  margin-left: 12px;
  margin-right: 12px;
  margin-top: 12px;
}
.dropdown {
  max-width: 50%;
}
.searchBox {
  max-width: 30%;
  display: flex;
  align-items: center;
}
.panel {
  margin-top: 12px;
}
.panels {
  margin-left: 20px;
  margin-right: 20px;
}
.buttonFooter {
  margin-top: 20px;
  margin-bottom: 20px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.button {
  margin-top: 40px;
  margin-bottom: 20px;
  display: block;
  margin-left: auto;
  margin-right: auto;}
</style>
